import React from 'react';
import Paper from 'apollo-react/components/Paper';
import Typography from '../StyledTypography';
import DateRangePicker from 'apollo-react/components/DateRangePicker';
import { useTranslation } from 'react-i18next';
import TextInput from '../Form/textInput';
import TagFilterSection from '../TagFilterSection/TagFilterSection';
import './styles.css';

const FiltersPanel = ({
  filters,
  onFilterChange,
  tagOptions,
  selectedTags = [],
  onTagChange,
}) => {
  const { t } = useTranslation();

  return (
    <Paper className="filter-container">
      <Typography variant="bodySmall" className="filter-title">
        {t('Filter')}
      </Typography>

      <TextInput
        label={t('Reference Number/Study Name')}
        placeholder={t('Search by reference number or study name')}
        value={filters.referenceOrStudyName}
        onChange={(value) => onFilterChange('referenceOrStudyName', value)}
        fullWidth
      />

      <Typography variant="bodySmall" className="filter-label">
        {t('Date Range')}
      </Typography>
      <div className="filter-date-container">
        <DateRangePicker
          value={filters.dateRange}
          onChange={(dateRange) => onFilterChange('dateRange', dateRange)}
          className="filter-date-picker"
        />
      </div>

      <TagFilterSection
        tagOptions={tagOptions}
        selectedTags={selectedTags}
        onTagChange={onTagChange}
      />
    </Paper>
  );
};

export default FiltersPanel;
